export enum ContactCompanyType {
  NoSet = 0,
  Owner = 1,
  Worker = 2,
  Reference = 3,
  NotDefined = 4, // ex
  Defined = 5 // attuale
}
